export enum ErrorHandlingTypeEnum {
  ALERT = "alert",
  FORM = "form",
  UNKNOWN = "unknown",
}
